"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Analytics = exports.analyticsEventCategory = void 0;
const authData_1 = require("../../private/ephemeral/authData");
const analyticsApi_1 = require("../../private/api-services/analyticsApi");
const jwtDecode = require("jwt-decode");
const env_1 = require("../../conf/env");
var analyticsEventCategory;
(function (analyticsEventCategory) {
    analyticsEventCategory["USER_EVENT"] = "user_event";
    analyticsEventCategory["ENDPOINT_CALLED"] = "endpoint_called";
    analyticsEventCategory["ERROR_EVENT"] = "error_events";
    analyticsEventCategory["ONBOARDING_EVENT"] = "OnboardingEvent"; // subcategory of user event, designed to track & analyse specific user events
})(analyticsEventCategory = exports.analyticsEventCategory || (exports.analyticsEventCategory = {}));
class Analytics {
    constructor() {
        this.logger = env_1.ANALYTICS_CLIENT;
        this.api = new analyticsApi_1.AnalyticsApi();
    }
    createUserEvent(category, type, data = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            if (env_1.ANALYTICS_DISABLED) {
                console.log("dev env - not sending event to analytics");
                return false;
            }
            const newEvent = {
                category,
                type,
                data,
                loggedBy: this.logger,
                username: 'unknown-user'
            };
            const token = authData_1.Auth.getUserToken();
            if (typeof token === 'string') {
                const user = jwtDecode(token);
                // @ts-ignore
                newEvent.userUuid = user['https://gloow.io/users/uuid'];
                // @ts-ignore
                newEvent.username = user.email;
            }
            const result = yield this.api.post("event", newEvent);
        });
    }
    logError(type, data) {
        if (env_1.ANALYTICS_DISABLED) {
            console.log("dev env - not sending error to analytics");
            return false;
        }
        const newEvent = {
            category: 'error_events',
            type,
            data,
            loggedBy: this.logger,
            username: 'unknown-user'
        };
        const token = authData_1.Auth.getUserToken();
        if (typeof token === 'string') {
            const user = jwtDecode(token);
            // @ts-ignore
            newEvent.userUuid = user['https://gloow.io/users/uuid'];
            // @ts-ignore
            newEvent.username = user.email;
        }
        this.api.post("event", newEvent);
    }
}
exports.Analytics = Analytics;
//# sourceMappingURL=data:application/json;base64,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